import { gql } from "@apollo/client";

export const FETCH_READING_MATERIAL = gql`
query FetchReadingMaterialByVideoId($video_id:UUID!) {
    fetchReadingMaterialByVideoId(video_id: $video_id) {
        data {
            reading_material {
                created_at
                description
                id
                name
                pdf
                updated_at
                video_id
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
